import { render, staticRenderFns } from "./ClickableCard.vue?vue&type=template&id=bff5c736&scoped=true"
import script from "./ClickableCard.vue?vue&type=script&lang=js"
export * from "./ClickableCard.vue?vue&type=script&lang=js"
import style0 from "./ClickableCard.vue?vue&type=style&index=0&id=bff5c736&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff5c736",
  null
  
)

export default component.exports